<!-- Cart -->
<section class="cart mb-4" *ngIf="cartDetails.order_details.length>0;else noProducts">
    <div class="cart-products">
        <div class="cart-product mb-4 p-3 bg-main-color" *ngFor="let cart of cartDetails?.order_details">
            <div class="row">
                <div class="col-lg-3">
                    <div class="cart-product-img bg-white py-4">
                        <img src="{{cart.product.images[0].image}}" alt="{{cart.product.name_en}}" class="img-fluid img-contain">
                    </div>
                </div>
                <div class="col-lg-9">
                    <div class="cart-product-name mb-4">
                        <h4 class="text-white text-truncate">{{cart.product.name_en}} <span class=" text-white float-right" (click)="removeFromCart(cart.product.id)"><i class="far fa-times-circle"></i></span></h4>
                    </div>
                    <div class="cart-product-amount-catergory mb-4">
                        <!-- <span
                            class="category rounded-pill px-4 py-1 d-inline-block mt-2">{{cart.product.brand.department.name_en}}</span> -->
                            <div class="sp-quantity counter d-inline-block float-right">
                                <div class="sp-minus fff "> <button class="ddd minus text-main-color border-0 bg-transparent" (click)="decrease(cart)">-</button>
                                </div>
                                <div class="sp-input">
                                    <input type="text" class="quntity-input text-secondary-color bg-transparent" disabled value="{{cart.quantity}}" min="1" >
                                </div>
                                <div class="sp-plus fff "> <button class="ddd plus text-main-color border-0 bg-transparent" (click)="increase(cart)">+</button>
                                </div>
                            </div>
                    </div>
                    <div class="cart-product-price">
                        <h5 class="text-secondary-color text-uppercase">{{cart.price}} sar</h5>
                    </div>
                </div>
            </div>
        </div>

    </div>
    
    <div class="application-summary mb-4" >
        <h6 class="bg-main-color px-3 text-white py-3 mb-4 text-uppercase rounded-pill"><i class="fas fa-star text-secondary-color"></i> Application Summary</h6>
        <div class="application-summary-info bg-white pt-4">
            <p class="text-uppercase px-4"><span class="font-weight-bold ">number of products</span> <span class="font-weight-bold float-right text-secondary-color">{{cartDetails.order_details.length}}</span></p>
            <!-- <p class="text-uppercase px-4"><span class="font-weight-bold">total request</span> <span class="font-weight-bold float-right text-secondary-color">{{t}} sar</span></p> -->
            <!-- <p class="text-uppercase px-4"><span class="font-weight-bold">discount</span> <span class="font-weight-bold float-right text-secondary-color">4%</span></p> -->
            <div class="total-price bg-main-color p-4">
                <p class="text-uppercase mb-0 "><span class="font-weight-bold text-white">total</span> <span class="font-weight-bold float-right text-secondary-color">{{totalPrice}} sar</span></p>
            </div>
        </div>
    </div>
    <div class="text-center">

        <button (click)="orderSet()" class="bg-main-color text-secondary-color px-5 py-2 border-0 font-weight-bold text-uppercase">add address Info</button>
    </div>
</section>

<ng-template #noProducts>
    <div class="card">
        <div class="card-body">
            <p class="text-center mb-0 py-5">No Products In Cart</p>
        </div>
    </div>
</ng-template>
<!-- ./Cart -->